/**
 * @generated SignedSource<<f7c5745827aa83ba3f6e780b786ccda4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useHardwareProductVersionsRelayQuery$variables = {
  id: string;
};
export type useHardwareProductVersionsRelayQuery$data = {
  readonly getHardwareProduct: {
    readonly hardwareProductVersions: ReadonlyArray<{
      readonly hardwareProductId: string;
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    }>;
    readonly id: string;
  } | null | undefined;
};
export type useHardwareProductVersionsRelayQuery = {
  response: useHardwareProductVersionsRelayQuery$data;
  variables: useHardwareProductVersionsRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "id"
      }
    ],
    "concreteType": "HardwareProduct",
    "kind": "LinkedField",
    "name": "getHardwareProduct",
    "plural": false,
    "selections": [
      (v1/*: any*/),
      {
        "alias": null,
        "args": [
          {
            "kind": "Literal",
            "name": "sort",
            "value": [
              {
                "field": "NAME",
                "order": "ASC"
              }
            ]
          }
        ],
        "concreteType": "HardwareProductVersion",
        "kind": "LinkedField",
        "name": "hardwareProductVersions",
        "plural": true,
        "selections": [
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "oldId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "name",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hardwareProductId",
            "storageKey": null
          }
        ],
        "storageKey": "hardwareProductVersions(sort:[{\"field\":\"NAME\",\"order\":\"ASC\"}])"
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHardwareProductVersionsRelayQuery",
    "selections": (v2/*: any*/),
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHardwareProductVersionsRelayQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "116d677721e39c4bd2d3ee028b3ecedd",
    "id": null,
    "metadata": {},
    "name": "useHardwareProductVersionsRelayQuery",
    "operationKind": "query",
    "text": "query useHardwareProductVersionsRelayQuery(\n  $id: ID!\n) {\n  getHardwareProduct(id: $id) {\n    id\n    hardwareProductVersions(sort: [{field: NAME, order: ASC}]) {\n      id\n      oldId\n      name\n      hardwareProductId\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "002ddf7e00b3e82230b741f8f51a9883";

export default node;
